






























































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { IContentSetVersion } from "../../../models/interfaces/content/content-set-version.model.interface";
import { IContentSetVersionTemplate } from "../../../models/interfaces/content/content-set-version-template.model.interface";
import { ContentSetVersionTemplateModel } from "../../../models/content/content-set-version-template.model";
import { IContentTemplate } from "../../../models/interfaces/content/content-template.model.interface";
import { ContentTemplateModel } from "../../../models/content/content-template.model";
import ContentTemplateEditor from "@/components/contentset/manager/ContentTemplateEditor.vue";
import { formatService } from "../../../services/format.service";

const ContentSetVersionModule = namespace("contentSetVersionModule");

@Component({
  components: {
    ContentTemplateEditor
  }
})
export default class TemplateTable extends Vue {
  @ContentSetVersionModule.Action public removeTemplate;
  @ContentSetVersionModule.Action public updateMultivariatePercentages;

  get getVersion(): IContentSetVersion {
    return this.version;
  }

  get showActions(): boolean {
    return this.showEdit || this.showDelete || this.showViewTemplate;
  }

  get hasItems(): boolean {
    if (this.items.length > 0) {
      return true;
    }
    return false;
  }

  @Prop() public version: IContentSetVersion;

  @Prop({ default: "Table" })
  public caption: string;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: true })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: true })
  public showPerformance: boolean;

  @Prop({ default: false })
  public showEdit: boolean;

  @Prop({ default: false })
  public showDelete: boolean;

  @Prop({ default: false })
  public showViewTemplate: boolean;

  @Provide() public items: IContentSetVersionTemplate[] = [];

  @Provide() private columns: any[] = [];

  private templateModel: IContentTemplate = new ContentTemplateModel();

  private showContentEditor: boolean = false;

  private readonlyTemplate: boolean = false;

  private loading: boolean = true;

  private deleteModalVisible: boolean = false;

  private selectedTemplate: IContentSetVersionTemplate;

  private editingMultivariate: boolean = false;

  private validMultivariate: boolean = true;

  public updateTemplateModalState(templateModalState: boolean) {
    this.showContentEditor = templateModalState;
  }

  public updateColumns() {
    this.columns = [
      {
        key: "templateId",
        label: "Template Id",
        class: "align-middle"
      },
      {
        key: "createdDate",
        label: "Created Date",
        class: "align-middle"
      },
      {
        key: "name",
        label: "Name",
        class: "align-middle"
      },
      {
        key: "multivariatePercent",
        label: "Share",
        class: "align-middle",
        formatter: (value, key, item) => {
          return item;
        },
        variant: this.validMultivariate ? "" : "danger"
      },
      {
        key: "performance.impressions",
        label: "Impressions (users)",
        formatter: (value, key, item) => {
          if (item.performance) {
            return formatService.formatNumber(item.performance.impressions);
          }
        },
        class: this.showPerformance ? "align-middle" : "d-none"
      },
      {
        key: "performance.keyPresses",
        label: "Engagements",
        sortable: true,
        formatter: (value, key, item) => {
          if(item.performance) {
            return formatService.formatNumberPercentage(
              value,
              item.performance.keyPresses,
              item.performance.impressions
            );
          }
        }
      },
      {
        key: "performance.clicks",
        label: "Clicks",
        formatter: (value, key, item) => {
          if (item.performance) {
            return formatService.formatNumberPercentage(
              value,
              item.performance.clicks,
              item.performance.impressions
            );
          }
       },
        class: this.showPerformance ? "align-middle" : "d-none"
      },
      {
        key: "enquiry.enquiries",
        label: "Enquiries",
        formatter: (value, key, item) => {
          if (item.enquiry && item.performance) {
            return formatService.formatNumberPercentage(
              value,
              item.enquiry.enquiries,
              item.performance.clicks
            );
          }
        },
        class: this.showPerformance ? "align-middle" : "d-none"
      },
      {
        key: "enquiry.conversions",
        label: "Conversions",
        formatter: (value, key, item) => {
          if (item.enquiry) {
            return formatService.formatNumberPercentage(
              value,
              item.enquiry.conversions,
              item.enquiry.enquiries
            );
          }
        },
        class: this.showPerformance ? "align-middle" : "d-none"
      },
      {
        key: "enquiry.revenue",
        label: "Revenue",
        formatter: (value, key, item) => {
          if (item.enquiry) {
            return formatService.formatCurrency(value);
          }
        },
        class: this.showPerformance ? "align-middle" : "d-none"
      },
      {
        key: "actions",
        formatter: (value, key, item) => {
          return item;
        },
        class: this.showActions ? "align-middle" : "d-none"
      }
    ];
  }

  @Watch("getVersion", { deep: true })
  public onContentSetVersionUpdate() {
    this.updateItems();
  }

  @Watch("validMultivariate")
  public onMultivariateUpdate() {
    this.updateColumns();
  }

  public emptyItems() {
    this.items.splice(0, this.items.length);
  }

  public updateItems() {
    this.emptyItems();

    const templates = this.getVersion.templates;
    if (templates && templates.length > 0) {
      templates.forEach((element, i) => {
        this.$set(this.items, i, element);
      });
    }
  }

  public showDeleteModal(template: IContentSetVersionTemplate) {
    this.selectedTemplate = template;
    this.deleteModalVisible = true;
  }

  public hideDeleteModal() {
    this.deleteModalVisible = false;
  }

  public editMultivariate() {
    this.editingMultivariate = true;
  }

  public saveMultivariate() {
    const valid = this.validateMultivariate();
    if (valid) {
      this.updateMultivariatePercentages(this.items).then((result) => {
        this.validMultivariate = true;
        this.editingMultivariate = false;
      });
    } else {
      this.validMultivariate = false;
    }
  }

  public validateMultivariate(): boolean {
    const invalidItems = this.items.filter((x) => x.multivariatePercent < 0);

    return invalidItems.length === 0;
  }

  public deleteTemplate() {
    if (this.selectedTemplate) {
      this.removeTemplate(this.selectedTemplate.templateId).then((result) => {
        if (result) {
          this.deleteModalVisible = false;
        }
      });
    }
  }

  public created() {
    this.updateColumns();
    this.updateItems();
  }

  private editTemplate(template: IContentTemplate, readonly: boolean) {
    this.templateModel = template;
    this.showContentEditor = true;
    this.readonlyTemplate = readonly;
  }
}
